import type * as React from 'react';
import { useMemo } from 'react';
import type { TenantId } from '@etiquetachef/types';
import { AuditList } from './AuditList';

type Props = { tenantId: TenantId };

/**
 * Aba "Auditoria" do detalhe do tenant: o log `/audit` filtrado pelo tenant.
 *
 * Origem: sem issue — commit 05030f0d1, 2026-04-26 17:26 +0200 (aba Audit do
 * tenant + página /audit global, Sprint 2).
 *
 * Contrato: filtra só por `targetId = tenantId` (ver comentário abaixo) e
 * delega lista, busca e diff ao `AuditList`.
 *
 * Usado por (admin): `routes/TenantDetailPage.tsx` (aba de `/tenants/:id`).
 *
 * Falhas conhecidas:
 *  - 2026-06-09 (8cdeee7d5): filtrava `targetType=TENANT` e escondia os
 *    eventos BILLING — a aba aparecia vazia.
 *
 * Histórico:
 *  - 2026-06-09 17:23 +0200 — (8cdeee7d5) filtro só por `targetId`.
 *  - 2026-10-10 15:12 +0200 — (#936) cabeçalho padrão (#796).
 */
export function TenantAuditTab({ tenantId }: Props): React.JSX.Element {
  // Filtra só por targetId (= tenantId): traz eventos TENANT (lifecycle) E
  // BILLING (plano/assinatura), que usam targetId = tenantId. Restringir a
  // targetType=TENANT escondia os eventos de billing (aba aparecia vazia).
  const filters = useMemo(
    () => ({
      targetId: tenantId,
    }),
    [tenantId],
  );
  return <AuditList filters={filters} />;
}
